import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { LocationOn, Close, Menu } from 'emotion-icons/material';
import React__default, { useState } from 'react';
import { HEADER } from '../../utils/dataTrackingValues.js';
import Link from '../Link/index.js';
import { TopBar, LocationChanger, ChildContainer, TopBarText, TopNav, Header as Header$2, BottomBar, TextBlock, CallToActions, MainNav, MobileHeader, MobileMenuButton, Border } from './Header.styles.js';
import MobileNav from './MobileNav.js';
import RenderNavItems from './RenderNavItems.js';

var _excluded = ["requestId", "navData", "topBarNavData", "userLocation", "hideLocation", "reverseTopBar", "logo", "logoLink", "children", "navigationPosition", "navigationBackgroundColor", "navigationTextColor", "headerBackgroundColor", "headerTextColor", "topBarBackgroundColor", "topBarTextColor", "hoverBackgroundColor", "hoverTextColor", "borderColor", "borderHeight", "textBlock", "textBlockAlignment", "callToActions", "topBarText", "navigationVisibility"];
var Header = function Header(_ref) {
  var _textBlock$props, _userLocation$state, _userLocation$state2;
  var requestId = _ref.requestId,
    _ref$navData = _ref.navData,
    navData = _ref$navData === void 0 ? undefined : _ref$navData,
    _ref$topBarNavData = _ref.topBarNavData,
    topBarNavData = _ref$topBarNavData === void 0 ? null : _ref$topBarNavData,
    _ref$userLocation = _ref.userLocation,
    userLocation = _ref$userLocation === void 0 ? null : _ref$userLocation,
    _ref$hideLocation = _ref.hideLocation,
    hideLocation = _ref$hideLocation === void 0 ? false : _ref$hideLocation,
    _ref$reverseTopBar = _ref.reverseTopBar,
    reverseTopBar = _ref$reverseTopBar === void 0 ? false : _ref$reverseTopBar,
    _ref$logo = _ref.logo,
    logo = _ref$logo === void 0 ? null : _ref$logo,
    _ref$logoLink = _ref.logoLink,
    logoLink = _ref$logoLink === void 0 ? null : _ref$logoLink,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$navigationPositi = _ref.navigationPosition,
    navigationPosition = _ref$navigationPositi === void 0 ? null : _ref$navigationPositi,
    _ref$navigationBackgr = _ref.navigationBackgroundColor,
    navigationBackgroundColor = _ref$navigationBackgr === void 0 ? null : _ref$navigationBackgr,
    _ref$navigationTextCo = _ref.navigationTextColor,
    navigationTextColor = _ref$navigationTextCo === void 0 ? null : _ref$navigationTextCo,
    _ref$headerBackground = _ref.headerBackgroundColor,
    headerBackgroundColor = _ref$headerBackground === void 0 ? null : _ref$headerBackground,
    _ref$headerTextColor = _ref.headerTextColor,
    headerTextColor = _ref$headerTextColor === void 0 ? null : _ref$headerTextColor,
    _ref$topBarBackground = _ref.topBarBackgroundColor,
    topBarBackgroundColor = _ref$topBarBackground === void 0 ? null : _ref$topBarBackground,
    _ref$topBarTextColor = _ref.topBarTextColor,
    topBarTextColor = _ref$topBarTextColor === void 0 ? null : _ref$topBarTextColor,
    _ref$hoverBackgroundC = _ref.hoverBackgroundColor,
    hoverBackgroundColor = _ref$hoverBackgroundC === void 0 ? null : _ref$hoverBackgroundC,
    _ref$hoverTextColor = _ref.hoverTextColor,
    hoverTextColor = _ref$hoverTextColor === void 0 ? null : _ref$hoverTextColor,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? null : _ref$borderColor,
    _ref$borderHeight = _ref.borderHeight,
    borderHeight = _ref$borderHeight === void 0 ? null : _ref$borderHeight,
    _ref$textBlock = _ref.textBlock,
    textBlock = _ref$textBlock === void 0 ? null : _ref$textBlock,
    _ref$textBlockAlignme = _ref.textBlockAlignment,
    textBlockAlignment = _ref$textBlockAlignme === void 0 ? null : _ref$textBlockAlignme,
    callToActions = _ref.callToActions,
    _ref$topBarText = _ref.topBarText,
    topBarText = _ref$topBarText === void 0 ? null : _ref$topBarText,
    _ref$navigationVisibi = _ref.navigationVisibility,
    navigationVisibility = _ref$navigationVisibi === void 0 ? null : _ref$navigationVisibi,
    props = _objectWithoutProperties(_ref, _excluded);
  var headerBgColor = headerBackgroundColor === null || headerBackgroundColor === void 0 ? void 0 : headerBackgroundColor.toLowerCase();
  var headerColor = headerTextColor === null || headerTextColor === void 0 ? void 0 : headerTextColor.toLowerCase();
  var topBarBgColor = topBarBackgroundColor === null || topBarBackgroundColor === void 0 ? void 0 : topBarBackgroundColor.toLowerCase();
  var topBarColor = topBarTextColor === null || topBarTextColor === void 0 ? void 0 : topBarTextColor.toLowerCase();
  var navigationBgColor = navigationBackgroundColor === null || navigationBackgroundColor === void 0 ? void 0 : navigationBackgroundColor.toLowerCase();
  var navigationColor = navigationTextColor === null || navigationTextColor === void 0 ? void 0 : navigationTextColor.toLowerCase();
  var hoverBgColor = hoverBackgroundColor === null || hoverBackgroundColor === void 0 ? void 0 : hoverBackgroundColor.toLowerCase();
  var hoverColor = hoverTextColor === null || hoverTextColor === void 0 ? void 0 : hoverTextColor.toLowerCase();
  var border = borderColor === null || borderColor === void 0 ? void 0 : borderColor.toLowerCase();
  var hasTextBlock = (textBlock === null || textBlock === void 0 || (_textBlock$props = textBlock.props) === null || _textBlock$props === void 0 ? void 0 : _textBlock$props.children.length) > 0 || textBlock;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobileNavOpen = _useState2[0],
    setMobileNavOpen = _useState2[1];
  var navUnderLogo = navigationPosition === 'Under logo';
  // This allows us to pass gatsby-link down from gatsby-theme-leshen
  var getMobileMenuButton = function getMobileMenuButton() {
    if (typeof navData === 'undefined' || !(navData !== null && navData !== void 0 && navData.length) > 0) {
      return null;
    }
    if (isMobileNavOpen) {
      return /*#__PURE__*/React__default.createElement(Close, {
        size: 32,
        onClick: function onClick() {
          return setMobileNavOpen(false);
        }
      });
    }
    return /*#__PURE__*/React__default.createElement(Menu, {
      size: 32,
      onClick: function onClick() {
        return setMobileNavOpen(true);
      }
    });
  };
  var showTopBar = (topBarNavData === null || topBarNavData === void 0 ? void 0 : topBarNavData.length) > 0 || !hideLocation || topBarText;
  var renderCallToActions = function renderCallToActions() {
    if (callToActions && callToActions.length > 0) {
      return /*#__PURE__*/React__default.createElement(CallToActions, {
        textBlock: hasTextBlock
      }, callToActions.map(function (action, index) {
        return /*#__PURE__*/React__default.createElement("span", {
          key: (action === null || action === void 0 ? void 0 : action.key) || index
        }, action) // action.key doesn't exist now, but it's a good idea to add it in the future. Adding it now to bypass eslint
        ;
      }));
    }
    return callToActions;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showTopBar && /*#__PURE__*/React__default.createElement(TopBar, {
    reverseTopBar: reverseTopBar,
    className: "top-bar",
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor,
    topBarBackgroundColor: topBarBgColor,
    topBarTextColor: topBarColor
  }, /*#__PURE__*/React__default.createElement("div", null, !hideLocation && /*#__PURE__*/React__default.createElement(LocationChanger, {
    className: "location-changer"
  }, /*#__PURE__*/React__default.createElement(LocationOn, {
    size: "16px",
    className: "location-on"
  }), ' ', (userLocation === null || userLocation === void 0 ? void 0 : userLocation.city) && (userLocation === null || userLocation === void 0 || (_userLocation$state = userLocation.state) === null || _userLocation$state === void 0 ? void 0 : _userLocation$state.fullName) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, userLocation === null || userLocation === void 0 ? void 0 : userLocation.city, ", ", userLocation === null || userLocation === void 0 || (_userLocation$state2 = userLocation.state) === null || _userLocation$state2 === void 0 ? void 0 : _userLocation$state2.fullName), /*#__PURE__*/React__default.createElement(ChildContainer, {
    headerTextColor: headerColor,
    topBarTextColor: topBarColor
  }, children))), topBarText && /*#__PURE__*/React__default.createElement(TopBarText, null, topBarText), /*#__PURE__*/React__default.createElement(TopNav, {
    reverseTopBar: reverseTopBar,
    headerTextColor: headerColor,
    topBarTextColor: topBarColor,
    className: "top-nav"
  }, topBarNavData === null || topBarNavData === void 0 ? void 0 : topBarNavData.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Link, {
      className: "header-link",
      key: "".concat(item.text, "-").concat(index) // eslint-disable-line react/no-array-index-key
      ,
      to: (item === null || item === void 0 ? void 0 : item.link) || item.href,
      onClick: function onClick() {
        return HEADER.LINKS.handleClick(item.text, item.href, requestId);
      }
      // eslint-disable-next-line react/jsx-curly-newline
    }, item.text);
  }))), /*#__PURE__*/React__default.createElement(Header$2, _extends({
    role: "banner"
  }, props, {
    className: "leshen-header leshen-header-desktop",
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor,
    navUnderLogo: navUnderLogo,
    navigationVisibility: navigationVisibility === null || navigationVisibility === void 0 ? void 0 : navigationVisibility.toLowerCase()
  }), navUnderLogo && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BottomBar, {
    className: "bottom-bar",
    navUnderLogo: navUnderLogo,
    navigationBackgroundColor: navigationBgColor,
    navigationTextColor: navigationColor,
    headerBackgroundColor: headerBgColor
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: logoLink
  }, logo), textBlock && /*#__PURE__*/React__default.createElement(TextBlock, {
    navUnderLogo: navUnderLogo,
    textBlockAlignment: textBlockAlignment,
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor,
    topBarBackgroundColor: topBarBgColor,
    topBarTextColor: topBarColor
  }, textBlock), callToActions &&
  /*#__PURE__*/
  // if textBlock is present, we need to pass textBlock prop to right align the callToActions
  React__default.createElement(CallToActions, {
    textBlock: hasTextBlock
  }, renderCallToActions())), /*#__PURE__*/React__default.createElement(MainNav, {
    role: "navigation",
    className: "main-nav",
    navUnderLogo: navUnderLogo,
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor,
    navigationBackgroundColor: navigationBgColor,
    navigationTextColor: navigationColor,
    hoverBackgroundColor: hoverBgColor,
    hoverTextColor: hoverColor
  }, (navData === null || navData === void 0 ? void 0 : navData.length) > 0 && /*#__PURE__*/React__default.createElement(RenderNavItems, {
    className: "render-nav-items",
    navData: navData,
    Link: Link
  }))), !navUnderLogo && /*#__PURE__*/React__default.createElement(BottomBar, {
    className: "bottom-bar",
    navigationTextColor: navigationTextColor,
    headerBackgroundColor: headerBgColor,
    navigationBackgroundColor: navigationBgColor,
    navUnderLogo: navUnderLogo
  }, /*#__PURE__*/React__default.createElement(MainNav, {
    role: "navigation",
    className: "main-nav",
    navUnderLogo: navUnderLogo,
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor,
    navigationBackgroundColor: navigationBgColor,
    navigationTextColor: navigationColor,
    hoverBackgroundColor: hoverBgColor,
    hoverTextColor: hoverColor
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: logoLink
  }, logo), (navData === null || navData === void 0 ? void 0 : navData.length) > 0 && /*#__PURE__*/React__default.createElement(RenderNavItems, {
    className: "render-nav-items",
    navData: navData,
    Link: Link
  })), textBlock && /*#__PURE__*/React__default.createElement(TextBlock, {
    textBlockAlignment: textBlockAlignment,
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor
  }, textBlock), callToActions && /*#__PURE__*/React__default.createElement(CallToActions, {
    textBlock: hasTextBlock
  }, renderCallToActions()))), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MobileHeader, {
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor,
    navigationBackgroundColor: navigationBgColor,
    navigationTextColor: navigationColor,
    navigationVisibility: navigationVisibility === null || navigationVisibility === void 0 ? void 0 : navigationVisibility.toLowerCase(),
    className: "leshen-header leshen-header-mobile"
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: logoLink
  }, logo), /*#__PURE__*/React__default.createElement(MobileMenuButton, {
    className: "menu-button",
    navigationBackgroundColor: headerBgColor,
    navigationTextColor: headerColor
  }, getMobileMenuButton())), isMobileNavOpen && /*#__PURE__*/React__default.createElement(MobileNav, {
    className: "leshen-header-mobile-nav",
    navData: navData,
    headerBackgroundColor: headerBgColor,
    headerTextColor: headerColor,
    isMobileNavOpen: isMobileNavOpen,
    navigationBackgroundColor: navigationBgColor,
    navigationTextColor: navigationColor,
    hoverBackgroundColor: hoverBgColor,
    hoverTextColor: hoverColor,
    navigationVisibility: navigationVisibility === null || navigationVisibility === void 0 ? void 0 : navigationVisibility.toLowerCase()
  })), /*#__PURE__*/React__default.createElement(Border, {
    borderColor: border,
    borderHeight: borderHeight
  }));
};
var Header$1 = Header;

export { Header$1 as default };
//# sourceMappingURL=index.js.map
